import { getSingleFeedback, submitFeedbackComment, getFeedbackComments } from "../../data/dataApi";
import ContentWrapper from "../../views/components/ContentWrapper";
import { useEffect, useState, useRef } from 'react';
import { useParams, Link, useNavigate, useLocation } from 'react-router-dom';
import { ReactComponent as ThumbUpOn } from "../../images/thumb-up-on.svg";
import { ReactComponent as ThumbUpOff } from "../../images/thumb-up-off.svg";
import { ReactComponent as ThumbDownOn } from "../../images/thumb-down-on.svg";
import { ReactComponent as ThumbDownOff } from "../../images/thumb-down-off.svg";
import { Form, Button } from "react-bootstrap";
import ConfirmationModal from "../../views/components/ConfirmationModal";
import { addBotInfo } from "../../data/dataApi";
import { useUserState } from "../../views/components/UserStateProvider";

const SingleFeedback = () => {
    const { userRole, userCapabilities } = useUserState();

    const [singleFeedback, setSingleFeedback] = useState(); 
    const { id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const [informValue, setInformValue] = useState('');
    const [informError, setInformError] = useState('');
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [submittingBotInfo, setSubmittingBotInfo] = useState(false);
    const [comments, setComments] = useState([]);
    const [comment, setComment] = useState('');
    const [commentError, setCommentError] = useState('');

    const formRef = useRef(null);

    const handleSubmit = async (event) => {
        setSubmittingBotInfo(true);
        event.preventDefault();

        setInformError("");

        if(informValue.trim() === "") {
            setInformError("Please type new content.");
        } else {
            const response = await addBotInfo(informValue);

            if(response.success) {
                setInformValue("");
                setShowConfirmationModal(true);
            } else {
                setInformError(response.error.message);
            }
        }
        setSubmittingBotInfo(false);
    };

    const handleCommentSubmit = async e => {
        e.preventDefault();

        if(comment.trim() !== '') {
            const response = await submitFeedbackComment(id, comment);

            if(response.success) {
                setComment('');
                setComments(response.data.rows);
            } else {
                setCommentError(response.error.message);
            }
        } else {
            setCommentError('Please enter a comment.');
        }
    };

    useEffect(() => {
        (async () => {
            const response = await getSingleFeedback(id);
                        
            if(response.success) {
                setSingleFeedback(response.data.rows[0]);
            }

            const commentsResponse = await getFeedbackComments(id);

            if(commentsResponse.success) {
                setComments(commentsResponse.data.rows);
            }
        })();
    }, [id]);

    return (
        <ContentWrapper className="single-feedback scrollable">
            <div className="back-wrapper">
                <button className="dashboard-tertiary-btn"
                    onClick={() => {
                        if (location.key === 'default') {
                        navigate('/dashboard/feedback')
                        } else {
                        navigate(-1)
                        }
                    }}>
                    Back
                </button>
            </div>
            <div className="wrapper tif-bg-color-tertiary tif-bg-light-color-white">
                <div className="table-wrapper">
                    <table className="secondary-table w-100">
                        {singleFeedback && <tbody className="secondary-body">
                            <tr>
                                <td width={238}><b>ID</b></td>
                                <td>{singleFeedback.id}</td>
                            </tr>
                            <tr>
                                <td><b>User IP</b></td>
                                <td>{singleFeedback.user_ip}</td>
                            </tr>
                            <tr>
                                <td><b>Country</b></td>
                                <td>{singleFeedback.country}</td>
                            </tr>
                            <tr>
                                <td><b>Time</b></td>
                                <td>{singleFeedback.time}</td>
                            </tr>
                            <tr>
                                <td><b>User Feedback</b></td>
                                <td>{singleFeedback.user_feedback}</td>
                            </tr>
                            <tr>
                                <td><b>Reason</b></td>
                                <td>{singleFeedback.reason && JSON.parse(singleFeedback.reason).map((reason, reasonIndex) => (
                                        <div key={reasonIndex}>{reason}</div>
                                    ))}
                                </td>
                            </tr>
                            <tr>
                                <td><b>User message</b></td>
                                <td>{singleFeedback.user_message}</td>
                            </tr>
                            <tr>
                                <td><b>Response</b></td>
                                <td dangerouslySetInnerHTML={{ __html: singleFeedback.api_response }} />
                            </tr>
                            <tr>
                                <td><b>Rating</b></td>
                                <td><div className="rating-cell">
                                        {
                                            singleFeedback.rating === "up" ?
                                                <>
                                                    <div>
                                                        <ThumbUpOn className="thumb-up-on tif-ml-md-5 tif-ml-0" />
                                                        <ThumbDownOff className="thumb-down-off tif-ml-md-10 tif-ml-5" />
                                                    </div>
                                                </>
                                            :
                                                <>
                                                    <div>
                                                        <ThumbUpOff className="thumb-up-off tif-ml-md-5 tif-ml-0" />
                                                        <ThumbDownOn className="thumb-down-on tif-ml-md-10 tif-ml-5" />
                                                    </div>
                                                    
                                                    {
                                                        userRole === "admin" &&
                                                        <Button className="link-out"
                                                            onClick={() => {
                                                                if (formRef.current) {
                                                                    formRef.current.scrollIntoView({ behavior: 'smooth' });
                                                                }
                                                            }}>
                                                            Inform the Bot
                                                        </Button>
                                                    }
                                                </>
                                        }
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td><b>User Email</b></td>
                                <td>{singleFeedback.user_email}</td>
                            </tr>
                            <tr>
                                <td><b>Chat History</b></td>
                                <td>
                                    <Link to={`/dashboard/history/${singleFeedback.session_id}`} className="link-out">View</Link>
                                </td>
                            </tr>
                        </tbody>}

                    </table>

                    {/* {
                        (userCapabilities.includes("create_inform_the_bot") && singleFeedback && singleFeedback.rating === "down") &&
                        <>
                            <table className="secondary-table w-100 tif-mb-35 tif-mt-85">
                                <thead>
                                    <tr>
                                        <td>Inform the Bot</td>
                                    </tr>
                                </thead>
                            </table>

                            <Form ref={formRef} className="secondary-form" onSubmit={handleSubmit}>
                                <Form.Group className="form-group" controlId="formTextArea">
                                    <Form.Label>Type correct answer to the question below.</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={1}
                                        value={informValue}
                                        onChange={(e) => setInformValue(e.target.value)}
                                        placeholder="Type here"
                                    />
                                </Form.Group>
                                { informError && <p className="error-text">{ informError }</p> }
                                <Button className="dashboard-quarternary-btn tif-mt-155" type="submit" disabled={submittingBotInfo}>
                                    { submittingBotInfo ? "Saving..." : "Save" }
                                </Button>
                            </Form>
                        </>
                    } */}

                    <div id="comments">
                        <h2 className="tif-h3 fw-bold tif-mb-35 tif-mt-85">Comments</h2>
                        <ul className="list-unstyled">
                            {
                                comments.map((comment, commentIndex) => (
                                    <li key={commentIndex} className="tif-pb-20 tif-mb-20">
                                        <p className="fw-bold tif-mb-5">{comment.email} | <span className="fw-normal">{ new Date(comment.created_at).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric' }) }</span></p>
                                        <p dangerouslySetInnerHTML={{ __html: comment.comment.replace(/\n/g, '<br />') }}></p>
                                    </li>
                                ))
                            }
                        </ul>

                        <Form className="secondary-form tif-mt-50" onSubmit={handleCommentSubmit}>
                            <Form.Group className="form-group" controlId="formTextArea">
                                <Form.Label>Add a comment</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={1}
                                    placeholder="Type here"
                                    className="medium"
                                    value={comment}
                                    onChange={(e) => setComment(e.target.value)}
                                />
                            </Form.Group>
                            { commentError && <p className="error-text text-start">{ commentError }</p> }
                            <Button className="dashboard-quarternary-btn tif-mt-75" type="submit">
                                Submit
                            </Button>
                        </Form>
                    </div>
                </div>
            </div>
            <ConfirmationModal 
                show={showConfirmationModal}
                changeVisibility={setShowConfirmationModal} 
                type="success"
                successMessage="You have successfully added new information."
                close={
                    <Button className="dashboard-tertiary-btn" onClick={() => setShowConfirmationModal(false)}>
                        Back to Feedback
                    </Button>
                }
            />
        </ContentWrapper>
    );
}

export default SingleFeedback;